module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "column centered-start cotacao-manual-main-container"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row-flex all-start w-100 gap-5"
  }, [_c('div', {
    ref: "nomeItemCotacao",
    staticClass: "column all-start cotacao-input-container"
  }, [_c('label', {
    staticClass: "f-required"
  }, [_vm._v("Item de cotação:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.nomeItem),
      expression: "nomeItem"
    }],
    staticClass: "form-control",
    class: _vm.errorInput ? 'error-input' : '',
    attrs: {
      "disabled": this.visualizacao,
      "type": "text",
      "placeholder": "Digite o nome do item a ser cotado, ref. histórico do cronograma."
    },
    domProps: {
      "value": (_vm.nomeItem)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.nomeItem = $event.target.value
      }, function($event) {
        _vm.errorInput = false
      }]
    }
  })]), _vm._v(" "), _c('div', {
    ref: "nomeItemCotacao",
    staticClass: "column all-start cotacao-input-container"
  }, [_c('label', {
    staticClass: "f-required"
  }, [_vm._v("Valor:")]), _vm._v(" "), _c('money', {
    staticClass: "form-control",
    attrs: {
      "disabled": this.visualizacao
    },
    model: {
      value: (_vm.valor),
      callback: function($$v) {
        _vm.valor = $$v
      },
      expression: "valor"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "column start-centered cotacao-manual-anexo-container"
  }, [_c('label', {
    staticClass: "control-label f-required"
  }, [_vm._v("Anexo:")]), _vm._v(" "), (!_vm.carregandoAnexos) ? _c('uploadCotacaoManual', {
    staticClass: "w-100",
    attrs: {
      "propDocumentos": _vm.anexos,
      "localUso": "COTACAO_MANUAL",
      "maxFiles": 3,
      "disable": this.visualizacao
    }
  }) : _c('div', [_c('i', {
    staticClass: "fa fa-refresh fa-spin",
    staticStyle: {
      "top": "50%",
      "left": "50%",
      "position": "absolute",
      "font-size": "30px"
    }
  }), _vm._v("\n            Carregando Anexos...\n          ")])], 1), _vm._v(" "), _c('div', {
    ref: "nomeItemCotacao",
    staticClass: "column all-start cotacao-input-container"
  }, [_c('label', {
    staticClass: "f-required"
  }, [_vm._v("Justificativa:")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.justificativa),
      expression: "justificativa"
    }],
    staticClass: "form-control justificativa-input",
    attrs: {
      "type": "text",
      "disabled": this.visualizacao,
      "placeholder": "Escreva a Justificativa para cotação Manual ( ex: Produto não encontrado no sistema de cotação | Meu valor é melhor)"
    },
    domProps: {
      "value": (_vm.justificativa)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.justificativa = $event.target.value
      }
    }
  })]), _vm._v(" "), (!_vm.visualizacao) ? _c('div', {
    staticClass: "row-flex centered-end w-100 gap-5"
  }, [_c('g-button-ujarak', {
    attrs: {
      "color": "success"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.gravarResultado()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-save",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Salvar ")]), _vm._v(" "), _c('g-button-ujarak', {
    attrs: {
      "color": "error"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.toggleCotacaoManual(false)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-close",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Cancelar ")])], 1) : _c('div', {
    staticClass: "row-flex centered-end w-100 gap-5"
  }, [_c('g-button-ujarak', {
    attrs: {
      "color": "primary"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.toggleCotacaoManual(false)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-close",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Voltar ")])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row-flex centered-start cotacao-header-container"
  }, [_c('i', {
    staticClass: "fa fa-dollar"
  }), _vm._v(" Cotação Manual\n    ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-ec743260!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/comparativoPrecos/cotacaoManual.vue
// module id = 2104
// module chunks = 1